import Debug from 'debug';

export enum DEBUG_NAMESPACE {
  CALLBACKS_STORAGE = 'callbacks_storage',
  INFO = 'info',
  PUSHER = 'pusher',
  ROOT = 'root',
  SMART_ACTIONS = 'store_smart_actions',
  SOCIAL_LOGIN = 'social_login',
  STORE = 'store',
  STORE_AI_METADATA = 'store_ai_metadata',
  STORE_ARTIFACTS = 'store_artifacts',
  STORE_EMBED = 'store_embed',
  STORE_MEETING_SHARE = 'store_meeting_share',
  STORE_REDACTION = 'store_redaction',
  STORE_REQUEST_CONTENT = 'store_request_content',
  STORE_STATS = 'store_stats',
  STORE_TO_DO = 'store_to_do',
  STORE_TRANSCRIPTION = 'store_transcription',
  STORE_TRANSLATION = 'store_translation',
  TRACKING = 'tracking',
  VALIDATORS = 'validators',
  VIDEOJS = 'videojs',
  VIEWER_ITEM = 'item',
  VIEWER_MODULE = 'viewer_module',
  VIEWER_TEMPLATE = 'template',
}

export const useDebug = (module: DEBUG_NAMESPACE | string = DEBUG_NAMESPACE.ROOT) => {
  const debug = Debug(`copernicus:${module}`);
  const isDebugEnabled = debug.enabled;

  return { debug, isDebugEnabled };
};
